/**远程管控 */
export default [
    {
        name:'remotecontrol',
        path:'remotecontrol',
        meta: { title: '远程管控' },
        component: ()=>import('@/pages/remotecontrol/index.vue')
    }
]